import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
  AlphabetsDirective,
  AlphabetsWithSpaceDirective,
  AlphabetsWithSpaceCommaDirective,
  AlphaNumericDirective,
  AlphaNumericWithSHDirective,
  AlphaNumericWithSHCDirective,
  TrimSpaceDirective
} from '@app/directives/alphanumeric.directive';
import { ClickOutsideDirective } from '@app/directives/click-outside.directive';
import { DragAndDropDirective } from '@app/directives/drag-and-drop.directive';
import { LatitudeDirective, LongitudeDirective } from '@app/directives/lat-lon.directive';
import { DecimalOnlyDirective, MinMaxDirective, NumbersOnlyDirective, OnlyNumber } from '@app/directives/numbers.directive';
import { WindowScrollDirective } from '@app/directives/window-scroll.directive';

export const directives = [
  AlphabetsDirective,
  AlphabetsWithSpaceDirective,
  AlphabetsWithSpaceCommaDirective,
  AlphaNumericDirective,
  AlphaNumericWithSHDirective,
  AlphaNumericWithSHCDirective,
  TrimSpaceDirective,
  ClickOutsideDirective,
  DragAndDropDirective,
  LatitudeDirective,
  LongitudeDirective,
  DecimalOnlyDirective,
  OnlyNumber,
  NumbersOnlyDirective,
  MinMaxDirective,
  WindowScrollDirective
];

@NgModule({
  imports: [CommonModule],
  declarations: [...directives],
  exports: [...directives],
})
export class DirectivesModule { }